(ns minorodata.statuses.subs
  (:require
   ["date-fns" :refer [isAfter subDays]]
   [minorodata.statuses.domain :refer [extract-status->ui kind->failed-status]]
   [re-frame.core :as re-frame]))


(re-frame/reg-sub
 :statuses.subs/by-id
 (fn [db [_ kind]]
   (get-in db [:statuses kind] {})))


;; Signalled off `by-id` so a canvas of many nodes shares one app-db read, and only
;; the nodes whose own status changed re-render.
(re-frame/reg-sub
 :statuses.subs/entity
 (fn [[_ kind _]]
   (re-frame/subscribe [:statuses.subs/by-id kind]))
 (fn [by-id [_ _ id]]
   (get by-id id)))


(re-frame/reg-sub
 :statuses.subs/all
 (fn [[_ kind]]
   (re-frame/subscribe [:statuses.subs/by-id kind]))
 (fn [by-id _]
   (vals by-id)))


(re-frame/reg-sub
 :statuses.subs/failed
 (fn [[_ kind]]
   (re-frame/subscribe [:statuses.subs/all kind]))
 (fn [statuses [_ kind]]
   (let [failed (kind->failed-status kind)]
     (filterv #(= failed (:status %)) statuses))))


;; `now` is read when the sub recomputes, not on a timer.
(re-frame/reg-sub
 :statuses.subs/failed-today
 (fn [[_ kind]]
   (re-frame/subscribe [:statuses.subs/failed kind]))
 (fn [failures _]
   (let [cutoff (subDays (js/Date.) 1)]
     (filterv #(isAfter (js/Date. (:created-at %)) cutoff) failures))))


;; Kind specific rather than one sub taking a `kind`: each endpoint gives you
;; something different to build the card's `{:status :last-run}` from.
(re-frame/reg-sub
 :statuses.subs/extract-status
 :<- [:statuses.subs/by-id :extract]
 (fn [by-id [_ extract-id]]
   (when-let [run (get by-id extract-id)]
     (let [status (extract-status->ui (:status run))]
       {:status   status
        ;; no `:started-at` — the label and date render, the duration doesn't
        :last-run {:status status :completed-at (:created-at run)}}))))

(re-frame/reg-sub
 :statuses.subs/model-status
 :<- [:statuses.subs/by-id :model]
 (fn [by-id [_ model-id]]
   (when-let [entry (get by-id model-id)]
     {:status (:status entry) :last-run entry})))
